import { render, staticRenderFns } from "./Howtoorder.vue?vue&type=template&id=d4b927ba&scoped=true&"
import script from "./Howtoorder.vue?vue&type=script&lang=js&"
export * from "./Howtoorder.vue?vue&type=script&lang=js&"
import style0 from "./Howtoorder.vue?vue&type=style&index=0&id=d4b927ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b927ba",
  null
  
)

export default component.exports